<mat-drawer-container class="roles-container" autosize>
  <mat-drawer-content [class.drawer-open]="isDrawerOpen">
    <button mat-button class="menu" routerLink="/tasks-overview">BACK</button>
    <div class="left-panel">
      <div class="content">
        <div class="search-row">
          <mat-form-field class="field-input" appearance="outline">
            <mat-label>What is the user name?</mat-label>
            <input
              matInput
              ngModel
              #userIdInput="ngModel"
              class="userId"
              placeholder="What is the user name?"
              [(ngModel)]="userId"
              (keydown.enter)="onSearch()"
            />
          </mat-form-field>

          <button
            class="cdx-but-lg"
            color="primary"
            (click)="onSearch()"
            mat-flat-button
          >
            Search roles
          </button>
        </div>

        <button
          mat-button
          class="view-all-link"
          (click)="isDrawerOpen = true"
          (click)="viewAllUsers()"
        >
          View all existing users
        </button>

        @if (userSelected) {
        <mat-form-field appearance="outline" class="field-input">
          <mat-label>First name</mat-label>
          <input matInput [(ngModel)]="firstName" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="field-input">
          <mat-label>Last name</mat-label>
          <input matInput [(ngModel)]="lastName" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="field-input">
          <mat-label>Email address</mat-label>
          <input matInput [(ngModel)]="email" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="field-input">
          <mat-label>Team lead</mat-label>
          <mat-select [(ngModel)]="teamLead">
            @for (tl of teamLeads; track tl) {
            <mat-option [value]="tl">
              {{ tl }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <button
          mat-flat-button
          color="primary"
          class="button"
          (click)="saveUserInfo()"
        >
          Save user information
        </button>
        }
      </div>

      @if (userSelected) {
      <div class="right-panel">
        <div class="table-div">
          <table mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="role">
              <th mat-header-cell *matHeaderCellDef>Role name</th>
              <td
                class="role-name-cell"
                mat-cell
                *matCellDef="let element"
                class="role-name-cell"
              >
                {{ element.role }}
              </td>
            </ng-container>
            <ng-container matColumnDef="delete">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element" class="delete-cell">
                <span
                  class="material-symbols-outlined"
                  (click)="deleteRole(element.role)"
                  >delete</span
                >
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
        @if (userSelected) {
        <div class="list">
          <mat-form-field appearance="outline" class="add-role-field">
            <mat-label>Add new role</mat-label>
            <mat-select
              [(ngModel)]="selectedRole"
              (selectionChange)="onAddRole($event)"
            >
              @for (role of rolesToAdd; track role) {
              <mat-option [value]="role">
                {{ role }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
      </div>
      }
    </div>
  </mat-drawer-content>

  <mat-drawer
    [opened]="isDrawerOpen"
    mode="side"
    position="end"
    class="users-drawer"
    disableClose
  >
    <app-existing-users-list
      [refreshUserData]="refreshUserData"
      (closeUsersTable)="isDrawerOpen = false"
    ></app-existing-users-list>
  </mat-drawer>
</mat-drawer-container>
